export function isActionCreate(state) {
  return state.action === "create";
}

export function isActionEdit(state) {
  return state.action === "edit";
}
export function isActionUpdateState(state) {
  return state.action === "update-state";
}
export function isActionIncome(state) {
  return state.action === "income";
}

export function isBatteryMaintenanceTransfer(state) {
  return state.action === "battery-maintenance-transfer";
}



// WEBPACK FOOTER //
// ./src/modules/request-service/getters.js